<template>
  <VueFinalModal
    :click-to-close="false" 
    v-slot="{ params, close }"
    v-bind="$attrs"
    classes="flex justify-center items-center"
    :content-class="contentClass"
    v-on="$listeners"
  >
    <!-- 画面いっぱいのときはタイトル・補足・× も大きくする -->
    <span class="font-bold flex items-center" :class="fullScreen ? 'text-3xl' : 'text-lg'">
      <div class="flex flex-col w-full">
        <div class="flex items-center">
          <slot name="title"></slot>
          <span class="text-gray-500 font-normal ml-4 flex-1" :class="fullScreen ? 'text-xl' : 'text-sm'">
            <slot name="subtitle"></slot>
          </span>
          <!-- <button @click="close"> -->
          <button type="button" v-if="!xIconDisabled" @click="closeModal(close)">
            <XIcon :class="fullScreen ? 'h-10 w-10' : ''" />
          </button>
        </div>
        <div class="text-gray-500 font-normal ml-4 flex-1" :class="fullScreen ? 'text-xl' : 'text-sm'">
          <slot name="sub-header"></slot>
        </div>
      </div>
    </span>
    <div class="flex-grow overflow-y-auto pt-3">
      <slot v-bind:params="params"></slot>
    </div>
    <div class="items-center pt-3" :class="!isMobileDevice?'flex-shrink-0 flex justify-end':''">
      <slot name="action"></slot>
      <!-- <v-button class="vfm-btn" @click="$emit('confirm', close)">confirm</v-button>
      <v-button class="vfm-btn" @click="$emit('cancel', close)">cancel</v-button> -->
    </div>
    <!-- <button class="absolute top-0 right-0 mt-2 mr-2" @click="close">
      <XIcon />
    </button> -->
  </VueFinalModal>
</template>
<script>
import { VueFinalModal } from 'vue-final-modal'
import { XIcon } from '@vue-hero-icons/solid'
import * as utils from '@libs/utils'
export default {
  name: 'Modal',
  inheritAttrs: false,
  components: {
    VueFinalModal,
    XIcon
  },
  props: {
    forceClosedEvent: {
      type: Boolean,
      default: false
    },
    xIconDisabled: {
      type: Boolean,
      default: false
    },
    // スマホ・タブレットのとき画面いっぱいに表示する
    fullScreenOnMobile: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /**
     * スマホ・タブレット（mobile-device-detect の isMobile はタブレットも含む）
     */
    isMobileDevice() {
      return utils.deviceInfo.isMobile
    },

    /**
     * 画面いっぱいに表示するか
     */
    fullScreen() {
      return this.fullScreenOnMobile && this.isMobileDevice
    },

    /**
     * モーダル本体のクラス
     */
    contentClass() {
      const base = 'relative flex flex-col p-4 bg-white dark:bg-gray-900 overflow-auto safari-relative'
      if (this.fullScreen) {
        // 画面いっぱい（余白・角丸・枠線なし）
        return `${base} w-full h-full`
      }
      return `${base} max-h-full mx-4 border dark:border-gray-800 rounded`
    }
  },

  methods: {
    closeModal(closeFunc) {
      closeFunc()
      if (this.forceClosedEvent) {
        this.$emit('closed')
      }
    }
  }
}
</script>
